export default __webpack_public_path__ + "static/media/icon.db39951f.svg";